import {Component, OnInit} from "@angular/core";
import {AuthService, UsersService} from "../../../services";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {ValidationService} from "../../../services/validation.service";
import {TranslateService} from "@ngx-translate/core";
import * as Raven from "raven-js";
import {HelperService} from "../../../services/helperService";


@Component({
	selector: "tig-password",
	templateUrl: "forgot.component.html"
})
export class ForgotComponent implements OnInit
{


	/**
	 * Attributes
	 */
	model: any = {};
	loading = false;
	company: string;
	form_group: FormGroup;
	view: {show_form: boolean, error: boolean, message: string} = { show_form: true, error: false, message: "" };
    config: any;


	/**
	 * Function > constructor
	 * @param {AuthService} auth_service
	 * @param {FormBuilder} form_builder
	 * @param {TranslateService} translate_service
	 * @param {UsersService} user_service
	 * @param {HelperService} helper_service
	 */
	constructor
	(
		private auth_service: AuthService,
		private form_builder: FormBuilder,
		private translate_service: TranslateService,
		private user_service: UsersService,
		private helper_service: HelperService
	)
	{

        // get company string
        this.config = this.helper_service.getFromLocalstorage('config');
        this.company = this.config.company;

		this.form_group = form_builder.group({
			email: ["", [Validators.required, Validators.minLength(2), ValidationService.checkEmail]]
		});

	} // end function constructor


	/**
	 * Function > ngOnInit
	 * @return {void}
	 */
	ngOnInit(): void
	{
		// reset login status
		this.auth_service.logout();
	} // end function ngOnInit


	/**
	 * Function > onSubmit
	 * @desc login a user
	 * @return {void}
	 */
	onSubmit()
	{

		// form is valid
		if (this.form_group.valid)
		{

			this.model = this.form_group.getRawValue();
			this.loading = true;

			let data = {
				identifier: "password-forgot",
				lang: this.translate_service.currentLang,
				username: this.model.email.toLowerCase()
			};

			 this.user_service.sendMail(this.config.email_config.url_send, data)
			 .subscribe
			 (
			 	// login successful
			 	data => {
					this.view.show_form = false;
					this.view.message = "oPassword.sSuccess";
			 	},
			 	// error
			 	OBJ_error => {
					// Send error to Bug Tracking System
					Raven.captureException(OBJ_error);

					this.view.show_form = false;
					this.view.error = true;
					this.view.message = "error_default";
			 	}
			 );

		} // end if

	} // end function onSubmit


} // end class ForgotComponent
